import { matchPath, useLocation } from 'react-router-dom'
import { localStorageItemKeys } from '~constants/local-storage-items'
import {
  GuidedTourStatus,
  useGuidedToursList,
} from '../content/guided-tours-list'

const allowedTourStatuses: GuidedTourStatus[] = ['Not Seen', 'Started']

export function useTour() {
  const location = useLocation()
  const guidedToursList = useGuidedToursList()
  const pageTours = guidedToursList.filter((tour) =>
    tour.tourPaths.some((path) => matchPath({ path }, location.pathname)),
  )

  if (!pageTours.length) return null

  const replayTourId = localStorage.getItem(
    localStorageItemKeys.triggeredGuidedTour,
  )
  const replayTour = pageTours.find((tour) => tour.id === replayTourId)

  if (replayTour) return replayTour.isApplicable === false ? null : replayTour

  const pageTour = pageTours.find((tour) => tour.isApplicable !== false)

  return pageTour && allowedTourStatuses.includes(pageTour.status)
    ? pageTour
    : null
}
